import { render, staticRenderFns } from "./EditColumnModal.vue?vue&type=template&id=2bf1d204&scoped=true&"
import script from "./EditColumnModal.vue?vue&type=script&lang=js&"
export * from "./EditColumnModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf1d204",
  null
  
)

export default component.exports